import Footer from '@modules/layout/templates/footer'
import Nav from '@modules/layout/templates/nav'
import React from 'react'

const Layout: React.FC = ({ children }) => {
  return (
    <div className="flex flex-col min-h-[100vh] w-[100%]">
      <Nav />
      <main className="relative flex-1">{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
